import React from 'react';

export const DevelopmentFlag: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <span className={`text-warning fw-bold ${className}`}>
      <i>DEV</i>
    </span>
  );
};
